import {
  CardTypeTracking,
  HighlightsInfoTextCard,
  HighlightsInfoTextCardResponse,
  TextCardType,
} from './types';

export const TypeCardMap = {
  1: 'Antec. clínicos',
  2: 'Antec. cirúrgicos',
  3: 'Alergias',
  4: 'Antec. familiares',
  5: 'Medicamentos em uso',
  6: 'Hábitos',
  7: 'Últimos diagnósticos',
};

export const parseHighlightsInfo = (
  highlightInfo: HighlightsInfoTextCardResponse,
): HighlightsInfoTextCard => ({
  content: highlightInfo.content,
  id: highlightInfo.id,
  patientId: highlightInfo.patient_id,
  eventId: highlightInfo.event_id,
  physicianId: highlightInfo.physician_id,
  clinicId: highlightInfo.clinic_id,
  timeCreated: highlightInfo.time_created,
  typeCard: highlightInfo.type_card,
});

export const parseHighlightsInfoToApi = (
  highlightInfo: HighlightsInfoTextCard,
): HighlightsInfoTextCardResponse => ({
  content: highlightInfo.content,
  id: highlightInfo.id,
  patient_id: highlightInfo.patientId,
  event_id: highlightInfo.eventId,
  physician_id: highlightInfo.physicianId,
  clinic_id: highlightInfo.clinicId,
  time_created: highlightInfo.timeCreated,
  type_card: highlightInfo.typeCard,
});

export function getHighlightInfoClickedOnNavigation(
  direction: string,
  highlightsInfoList: HighlightsInfoTextCard[],
  highlightInfoSelected: HighlightsInfoTextCard,
) {
  const currentIndex = highlightsInfoList.findIndex(
    (card) => card.typeCard === highlightInfoSelected.typeCard,
  );

  const offset = direction === 'next' ? 1 : -1;
  const nextIndex =
    (currentIndex + offset + highlightsInfoList.length) %
    highlightsInfoList.length;

  return highlightsInfoList[nextIndex];
}

export function getPreviousAndNextHighlightInfoCardTypes(
  highlightsInfoList: HighlightsInfoTextCard[],
  highlightInfoSelected: HighlightsInfoTextCard,
) {
  const currentIndex = highlightsInfoList.findIndex(
    (card) => card.typeCard === highlightInfoSelected.typeCard,
  );
  const previousIndex =
    currentIndex === 0 ? highlightsInfoList.length - 1 : currentIndex - 1;
  const nextIndex =
    currentIndex === highlightsInfoList.length - 1 ? 0 : currentIndex + 1;

  const previousCardType =
    TypeCardMap[highlightsInfoList[previousIndex].typeCard];
  const nextCardType = TypeCardMap[highlightsInfoList[nextIndex].typeCard];

  return {
    previousCardType,
    nextCardType,
  };
}

export function getCardTypeTracking(cardType: TextCardType): CardTypeTracking {
  const cardTypeMapping = {
    1: CardTypeTracking.medicalHistory,
    2: CardTypeTracking.surgicalHistory,
    3: CardTypeTracking.alergies,
    4: CardTypeTracking.familyHistory,
    5: CardTypeTracking.drugsInUse,
    6: CardTypeTracking.habits,
    7: CardTypeTracking.lastDiagnosis,
  };

  return cardTypeMapping[cardType] || CardTypeTracking.custom;
}
